// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1dw8w","actionsCol":"EnrolledClinics_actionsCol__U4PyV"};